import React, { useState, useEffect } from "react";
import ModalPostCommunity from "./ModalPostCommunity";
import DatePicker from "react-date-picker";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Pagination from "react-js-pagination";
import {
  Community_List,
  Community_viewMembers,
  communityList_Status,
} from "../../../actions/auth";
import { MY_PROFILE, MY_PROFILE_COMMUNITY } from "../../../actions/types";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import swal from "sweetalert";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const ViewMembers = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [name, setName] = useState("");
  const [List, setList] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [total, setTotal] = useState("");
  const [searchData, setSearchData] = useState("");
  const [sortOrder, setSortOrder] = useState("desc"); // 'asc' or 'desc'
  const [sortField, setSortField] = useState(""); // 'asc' or 'desc'
  const [errorMessage, setErrorMessage] = useState("");
  const [imgError, setImgError] = useState("");
  const [description, setDescription] = useState(""); // State for the description input
  const [descError, setDescError] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [dateError, setDateError] = useState(""); // To show validation error message
  const [status, setStatus] = useState(""); // To show validation error message

  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  console.log(state, "state........");

  const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined dates
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero
    const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero
    const year = d.getFullYear(); // Get year
    return `${month}-${day}-${year}`; // Format as MM-DD-YYYY
  };

  const ApiCall = (
    activePage,
    itemsPerPage,
    state,
    searchData,
    sortOrder,
    sortField,
    fromDate,
    toDate
  ) => {
    dispatch(
      Community_viewMembers(
        activePage,
        itemsPerPage,
        state,
        searchData ? searchData : "",
        sortOrder || "",
        sortField || "",
        fromDate,
        toDate
      )
    ).then((response) => {
      console.log(
        response?.data?.meta?.totalCount,
        "response......................."
      );
      if (response?.status == true) {
        setTotal(response?.data?.meta?.totalCount);
        setList(response?.data);
      }
    });
  };

  useEffect(() => {
    setLoadingData(true);
    ApiCall(
      activePage,
      itemsPerPage,

      state,
      searchData ? searchData : "",
      sortOrder || "",
      sortField || "",
      formatDate(fromDate || ""),
      formatDate(toDate || "")
    );
  }, [activePage, searchData, fromDate, toDate]);

  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (!toDate) {
      setDateError("Please select To Date Also.");
    } else {
      setDateError(""); // Clear error if To Date is selected
    }
    if (!fromDate) {
      setDateError(""); // If no fromDate is selected, clear the error
    } else {
      setDateError(""); // Clear error when To Date is selected
    }
    if (!date) {
      setFromDate(null);
      setToDate(null); // Reset end date when start date is removed
    }
  };
  const handleToDateChange = (date) => {
    setToDate(date);
    setDateError(""); // Clear error when To Date is selected
    if (!fromDate) {
      setDateError(""); // If no fromDate is selected, clear the error
    } else {
      setDateError(""); // Clear error when To Date is selected
    }
  };

  const searchList = (e) => {
    const data = e.target.value.trimStart();
    setSearchData(data);
    setActivePage(1);
    if (data) {
      ApiCall(
        activePage,
        itemsPerPage,
        state,
        data,
        sortOrder || "",
        sortField || "",
        formatDate(fromDate || ""), // Format the fromDate
        formatDate(toDate || "")
      );
    }
  };
  const handleClearSearch = () => {
    if (searchData) {
      setSearchData("");
      setLoading(true);
      ApiCall(
        activePage,
        itemsPerPage,
        state,
        "",
        sortOrder || "",
        sortField || "",
        formatDate(fromDate || ""), // Format the fromDate
        formatDate(toDate || "")
      );
    }
  };

  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > total) {
      endIndex = total;
    }
    console.log(total, "endIndex.....");
    return `Showing ${startIndex} to ${endIndex} of ${total} entries`;
  };
  const handlePageChange = (pagenumber) => {
    if (pagenumber) {
      setLoadingData(true);
      dispatch(
        Community_List(
          pagenumber,
          itemsPerPage,
          searchData ? searchData : "",
          sortOrder || "",
          sortField || "",
          formatDate(fromDate || ""), // Format the fromDate
          formatDate(toDate || "")
        )
      ).then(() => {
        setLoadingData(false); // Stop loading
      });
      setActivePage(pagenumber);
    }
  };

  const Sortt = (col) => {
    // const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle sort order
    const newSortOrder = sortOrder === "desc" ? "asc" : "desc"; // Toggle sort order
    setSortField(col);
    setSortOrder(newSortOrder);
    setLoadingData(true);
    ApiCall(
      activePage,
      itemsPerPage,
      state,
      searchData ? searchData : "",
      newSortOrder,
      col,
      fromDate || "",
      toDate || ""
    );
  };

  const [image, setImage] = useState(""); // Default profile image
  const [EditID, setEditId] = useState("");
  const openModal = (isEdit = false, data = null) => {
    setIsEditMode(isEdit);
    if (isEdit && data) {
      setName(data && data.name);
      setDescription(data?.description || "");
      setImage(
        data?.image ? MY_PROFILE_COMMUNITY + data?.image : "img/noImage.png"
      );

      setEditId(data?._id);
    } else {
      setName("");
      setDescription("");
      setImage("");
      // setSelectedRadarId(null);
    }
    setModalIsOpen(true);
  };

  function toggleSwitch(e, event) {
    // const newStatusText = event.target.checked == true ? "1" : "0";
    const newStatusText2 = event.target.checked == true ? "active" : "inactive";

    document.body.classList.add("swal-open-modal");

    swal({
      text: `Are you sure you want to ${newStatusText2} this status?`,
      icon: "warning",
      buttons: true,
      className: "swal-custom-modal",
    }).then((willConfirm) => {
      document.body.classList.remove("swal-open-modal");
      setStatus(newStatusText2);
      if (willConfirm) {
        setLoadingData(true);

        dispatch(communityList_Status(e?._id, newStatusText2)).then(
          (response) => {
            if (response) {
              setLoadingData(true);
              ApiCall(
                newStatusText2,
                activePage,
                itemsPerPage,
                state,
                searchData ? searchData : "",
                sortOrder || "",
                sortField || "",
                formatDate(fromDate || ""), // Format the fromDate
                formatDate(toDate || "")
              );
              // dispatch(
              //   Community_List(
              //     newStatusText2,
              //     activePage,
              //     itemsPerPage,
              //     searchData ? searchData : "",
              //     sortOrder || "",
              //     sortField || "",
              //     formatDate(fromDate || ""), // Format the fromDate
              //     formatDate(toDate || "")
              //   )
              // ).then((response) => {
              //   if (response.success == true) {
              //     setTotal(response?.data?.meta?.totalCount.totalCount);
              //     setList(response.data);
              //   }
              // });
            }
          }
        );
      }
    });
  }

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n\n.react-date-picker__wrapper{\nborder:0px !important;\n}\n",
        }}
      />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Community Members
                  </h6>
                </div>
                <div className="card-body">
                  <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <div className="row mb-2 ">
                      <div className="col-md-4">
                        <label>Search:</label>
                        <input
                          type="text"
                          className="form-control search-input-new"
                          placeholder="Enter Member Name to search"
                          value={searchData}
                          onChange={searchList}
                          // onKeyDown={handleSearch}
                        />
                        {searchData?.length >= 1 && (
                          <div
                            onClick={handleClearSearch}
                            // className="cross-serach-new"
                            style={{
                              position: "absolute",
                              top: "40px",
                              right: "26px",
                            }}
                          >
                            <i className="fa fa-times cursor-pointerr"></i>
                          </div>
                        )}
                      </div>

                      {/* <div className="row mb-2 "> */}
                      <div className="col-3">
                        <label>Start Date:</label>
                        <DatePicker
                          className="form-control"
                          // selected={selectedDate}
                          value={fromDate}
                          onChange={handleFromDateChange}
                          maxDate={new Date()}
                          minDate={new Date(2015, 0, 1)}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="col-3">
                        <label>End Date:</label>
                        <DatePicker
                          className="form-control"
                          // selected={selectedDate}
                          value={toDate}
                          disabled={!fromDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        {dateError && (
                          <p className="text-danger">{dateError}</p>
                        )}
                      </div>
                      <div className="col-md-2" style={{ marginTop: "1.9rem" }}>
                        <ModalPostCommunity
                          id={state}

                          // newFunc={() => fetchPosts(page)}
                        />
                      </div>
                    </div>
                    {/* </div> */}
                  </div>
                </div>

                <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                  <table class="table radar-table">
                    <thead>
                      <tr>
                        <th scope="col">No. </th>
                        <th scope="col">
                          Member Name{" "}
                          <i
                            onClick={() => Sortt("firstname")}
                            className="fa fa-sort cursor-pointerr"
                            height="15px"
                            width="15px"
                            style={{ marginLeft: 5 }}
                          ></i>{" "}
                        </th>
                        <th scope="col">
                          Join Date{" "}
                          <i
                            onClick={() => Sortt("created_at")}
                            className="fa fa-sort cursor-pointerr"
                            height="15px"
                            width="15px"
                            style={{ marginLeft: 5 }}
                          ></i>{" "}
                        </th>
                        <th scope="col">
                          Posts{" "}
                          <i
                            onClick={() => Sortt("post_count")}
                            className="fa fa-sort cursor-pointerr"
                            height="15px"
                            width="15px"
                            style={{ marginLeft: 5 }}
                          ></i>{" "}
                        </th>

                        {List.members?.some(
                          (member) => member.user_type !== "admin"
                        ) ? (
                          <th scope="col">Action</th>
                        ) : (
                          <th scope="col"></th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {console.log(List && List?.members, "mylist")}
                      {List.members?.length > 0 ? (
                        List?.members.map((e, index) => (
                          <tr key={e._id}>
                            {console.log(e, "mansi")}
                            <th scope="row">
                              {(activePage - 1) * itemsPerPage + (index + 1)}
                            </th>
                            <td
                              className={`${
                                e?.user_type === "admin" ||
                                e?.user_type === "sub_admin"
                                  ? "cursor-default"
                                  : "cursor-pointerr"
                              }`}
                            >
                              {e?.user_type === "admin" ||
                              e?.user_type === "sub_admin" ? (
                                <>
                                  <img
                                    src={
                                      e?.user_id?.profile_image?.[0]
                                        ? `${MY_PROFILE}/${e?.user_id?.profile_image[0]}`
                                        : "img/noImage.png"
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = "img/noImage.png";
                                    }}
                                    style={{
                                      height: "50px",
                                      borderRadius: "50px",
                                      width: "50px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  {e?.user_id?.firstname}
                                </>
                              ) : (
                                <Link
                                  to={`/view-user-detail/${e?.user_id?._id}`}
                                >
                                  <img
                                    src={
                                      e?.user_id?.profile_image?.[0]
                                        ? `${MY_PROFILE}/${e?.user_id?.profile_image[0]}`
                                        : "img/noImage.png"
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = "img/noImage.png";
                                    }}
                                    style={{
                                      height: "50px",
                                      borderRadius: "50px",
                                      width: "50px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  {e?.user_id?.firstname}
                                </Link>
                              )}
                            </td>
                            <td>
                              {moment(e?.created_at).format("MM/DD/YYYY")}
                            </td>
                            <td>{e?.post_count}</td>
                            <td
                              className={`${
                                e?.user_type === "admin" ||
                                e?.user_type === "sub_admin"
                                  ? "cursor-default"
                                  : "cursor-pointerr"
                              }`}
                            >
                              {e?.user_type !== "admin" &&
                                e?.user_type !== "sub_admin" && (
                                  <Link
                                    to={`/view-user-detail/${e?.user_id?._id}`}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </Link>
                                )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6}>
                            <h5
                              style={{ textAlign: "center" }}
                              className="mt-3"
                            >
                              No results found
                            </h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {List.members && List.members?.length > 0 ? (
                    <div className="d-flex justify-content-between mt-3 align-items-center">
                      <ul className="mt-3 ps-0">
                        <p>
                          {/* {list && list?.data?.totalOptions > 0 */}
                          {calculateRange()}
                          {/* : ""} */}
                        </p>
                      </ul>
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={itemsPerPage}
                        totalItemsCount={total}
                        pageRangeDisplayed={10}
                        // onChange={handlePageChange}
                        onChange={
                          total > itemsPerPage ? handlePageChange : null
                        }
                        // itemClass="page-item"
                        itemClass={`page-item ${
                          total <= itemsPerPage ? "noPointerrr" : ""
                        }`}
                        linkClass={
                          total && total > 0
                            ? "page-link"
                            : "page-link disabled"
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewMembers;
